<template>
    <div>
        <div :class="{'slide-in':!display}" class="slide-out tw-bg-gray-50 tw-mb-0 tw-border-0 tw-absolute tw-top-full tw-inset-x-0 tw-z-50 tw-shadow-lg lg:tw-max-h-none lg:tw-static lg:tw-top-0 lg:tw-shadow-none">
            <slot></slot>
        </div>

        <portal to="navbar-toggle">
            <div @click="display = !display" ref="trigger" class="tw-bg-pia-red tw-text-white tw-justify-center tw-items-center tw-flex lg:tw-hidden hover:tw-bg-pia-shade" style="width: 40px; height: 40px;">
                <i class="fa fa-navicon"></i>
            </div>
        </portal>
    </div>
</template>

<script>
export default {
    name: "TheNavbar",

    data() {
        return {
            display: false
        }
    },

    mounted() {
        document.addEventListener('click', event => {
            if(!this.$el.contains(event.target) && !this.$refs.trigger.contains(event.target)) {
                this.display = false;
            }
        });
    },
}
</script>

<style scoped>
    .slide-out {
        max-height: 100vh;
        overflow: hidden;
        transition: max-height;
        -moz-transition-duration: 0.5s;
        -webkit-transition-duration: 0.5s;
        -o-transition-duration: 0.5s;
        transition-duration: 0.5s;
    }

    .slide-in {
        max-height: 0 !important;
    }

    @media (min-width: 992px) { 
        .slide-out {
            overflow: visible;
        }

        .slide-in {
            max-height: none !important;
        }
    }
</style>